import FinishGoodQualityInspectNgInbox from '@/models/FinishGoodQualityInspectInbox/FinishGoodQualityInspectNgInbox';

export default class FinishGoodQualityInspectNgInboxFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.problemCategoryId  = '';
		this.problemCategoryCode = '';
		this.qtyNg = '';
		this.finishGoodQualityInspectInboxId  = '';
		this.finishGoodQualityInspectInboxControlCard = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			problemCategoryId : '0',
			problemCategoryCode : '0',
			qtyNg : '0',
			finishGoodQualityInspectInboxId : '0',
			finishGoodQualityInspectInboxControlCard : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}